









import Vue from "vue";
import Component from "vue-class-component";
import Sars from "../targets/Sars.vue";
import Vessels from "../targets/Vessels.vue";
import AtonsLayer from "../targets/AtonsLayer.vue";
import BaseStationLayer from "../targets/BaseStationLayer.vue";
import { maps } from "@/store";

@Component({
  components: {
    Sars,
    Vessels,
    AtonsLayer,
    BaseStationLayer,
  },
})
export default class MapTargets extends Vue {
  get selectedTargets() {
    return maps.getters.selectedTargets;
  }
}
